import React, { useState } from 'react';
import { Check, Gift, Heart, ArrowRight, Sparkles, Calendar, CheckCircle2, ShieldCheck, Package, AlertTriangle, XCircle, ShieldAlert, Leaf, FileText, ShoppingCart, Headphones, Tag, Star, BookOpen, ChevronDown, ChevronUp } from 'lucide-react';
import { useOrderBumps, getActiveCheckoutUrl, getOrderTotal, getItemCount } from '../../hooks/useOrderBumps';
import { UpsellModal } from '../UpsellModal';
interface BenefitsSectionWithCheckoutProps {
  checkoutUrl: string;
  displayPrice?: string;
}
export function BenefitsSectionWithCheckout({
  checkoutUrl,
  displayPrice = '$19.999'
}: BenefitsSectionWithCheckoutProps) {
  const [showBonos, setShowBonos] = useState(false);
  const [showUpsell, setShowUpsell] = useState(false);
  const {
    bump1Selected,
    bump2Selected,
    setBump1Selected,
    setBump2Selected
  } = useOrderBumps();
  const activeCheckoutUrl = getActiveCheckoutUrl(checkoutUrl, bump1Selected, bump2Selected);
  const orderTotal = getOrderTotal(bump1Selected, bump2Selected);
  const itemCount = getItemCount(bump1Selected, bump2Selected);
  const DISCOUNT_CHECKOUT_URL = 'https://pay.hotmart.com/Q104389187Y?off=h96re49q&checkoutMode=10&bid=1771440501662';
  const handleCheckoutClick = (e: React.MouseEvent) => {
    // Order bumps hidden for now — go straight to checkout
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: '30 Recetas Anti-Inflamatorias para Mascotas',
        content_category: 'E-book',
        value: 19999,
        currency: 'COP',
        num_items: 1
      });
    }
  };
  return <section id="benefits-section" className="py-10" style={{
    backgroundColor: '#F8F6F1'
  }} data-id="element-238">
      <UpsellModal isOpen={showUpsell} onClose={() => setShowUpsell(false)} baseCheckoutUrl={checkoutUrl} discountCheckoutUrl={DISCOUNT_CHECKOUT_URL} data-id="element-239" />
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-240">
        <div className="text-center mb-6" data-id="element-241">
          <div className="inline-flex items-center gap-2 text-white px-6 py-2 rounded-full text-lg font-bold uppercase tracking-wide mb-6" style={{
          backgroundColor: '#F57C00'
        }} data-id="element-242">
            ⭐ OFERTA ESPECIAL HOY
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-3" style={{
          color: '#2F5D50'
        }} data-id="element-243">
            PROGRAMA CLÍNICO DE NUTRICIÓN NATURAL PARA PERROS
          </h2>
          <p className="text-lg text-gray-600 font-semibold" data-id="element-244">
            30 Recetas + 3 Regalos
          </p>

          {/* Main E-book Image */}
          <div className="max-w-sm mx-auto mt-6 rounded-xl overflow-hidden shadow-lg border-2" style={{
          borderColor: '#6DAA7F'
        }} data-id="element-245">
            <img src="https://cdn.magicpatterns.com/uploads/gnEaoFwYpACgNWsD1np27d/ChatGPT_Image_10_mar_2026,_04_47_53_p.m..png" alt="Programa Clínico de Nutrición Natural - 30 Recetas Anti-Inflamación para Perros" className="w-full h-auto object-cover" data-id="element-246" />
          </div>

          {/* Bonos desplegable + Sorteo */}
          <div className="max-w-xl mx-auto mt-4 bg-white border rounded-2xl overflow-hidden shadow-sm text-left" style={{
          borderColor: '#6DAA7F'
        }} data-id="element-247">
            <div className="p-4 border-b" style={{
            borderColor: '#e8f5ec'
          }} data-id="element-248">
              <button onClick={() => setShowBonos(!showBonos)} className="w-full flex items-center justify-center gap-1.5 text-sm font-semibold transition-colors" style={{
              color: '#2F5D50'
            }} data-id="element-249">
                {showBonos ? <>
                    <ChevronUp className="w-4 h-4" data-id="element-250" />
                    Ocultar detalle de regalos
                  </> : <>
                    <ChevronDown className="w-4 h-4" data-id="element-251" />
                    Ver qué incluyen los 3 regalos gratis
                  </>}
              </button>
              {showBonos && <div className="mt-3 space-y-3" data-id="element-252">
                  <div className="flex items-start gap-3 p-3 rounded-xl border" style={{
                backgroundColor: '#e8f5ec',
                borderColor: '#6DAA7F'
              }} data-id="element-253">
                    <img src="https://cdn.magicpatterns.com/uploads/9pgdegNzbQ4opBiEgx4YKA/heylloyd-image-1769029546802.png" alt="Cómo Alargar la Vida de tu Perro" className="w-14 object-cover object-top rounded-lg border flex-shrink-0" style={{
                  borderColor: '#6DAA7F'
                }} data-id="element-254" />
                    <div data-id="element-255">
                      <p className="text-sm font-bold text-gray-900" data-id="element-256">
                        Cómo Alargar la Vida de tu Perro
                      </p>
                      <p className="text-xs text-gray-600 mt-0.5" data-id="element-257">
                        Guía de hábitos diarios: rutina simple, prevención y
                        listas de chequeo imprimibles.
                      </p>
                      <p className="text-xs font-semibold mt-1" style={{
                    color: '#2F5D50'
                  }} data-id="element-258">
                        Valor: $49.999 COP — Hoy: GRATIS
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 rounded-xl border" style={{
                backgroundColor: '#FFF3E0',
                borderColor: '#F57C00'
              }} data-id="element-259">
                    <img src="https://cdn.magicpatterns.com/uploads/tmJCjjYa4iD56VcWj6sEtX/ChatGPT_Image_5_feb_2026,_12_53_16_p.m..png" alt="Plan Express 7 Días" className="w-14 object-cover object-top rounded-lg border flex-shrink-0" style={{
                  borderColor: '#F57C00'
                }} data-id="element-260" />
                    <div data-id="element-261">
                      <p className="text-sm font-bold text-gray-900" data-id="element-262">
                        Plan Express 7 Días: Transición Segura
                      </p>
                      <p className="text-xs text-gray-600 mt-0.5" data-id="element-263">
                        Plan paso a paso para cambiar a comida casera sin
                        diarrea ni malestar.
                      </p>
                      <p className="text-xs font-semibold mt-1" style={{
                    color: '#F57C00'
                  }} data-id="element-264">
                        Valor: $49.999 COP — Hoy: GRATIS
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 rounded-xl border" style={{
                backgroundColor: '#e8f5ec',
                borderColor: '#6DAA7F'
              }} data-id="element-265">
                    <img src="https://cdn.magicpatterns.com/uploads/dhzCPguBEHAuB1vxaooPGU/ChatGPT_Image_5_feb_2026,_02_35_47_p.m..png" alt="Lista Negra + Lista Verde" className="w-14 object-cover object-top rounded-lg border flex-shrink-0" style={{
                  borderColor: '#6DAA7F'
                }} data-id="element-266" />
                    <div data-id="element-267">
                      <p className="text-sm font-bold text-gray-900" data-id="element-268">
                        Lista Negra + Lista Verde
                      </p>
                      <p className="text-xs text-gray-600 mt-0.5" data-id="element-269">
                        Guía rápida de alimentos seguros, con cuidado y
                        prohibidos. Incluye hoja imprimible.
                      </p>
                      <p className="text-xs font-semibold mt-1" style={{
                    color: '#2F5D50'
                  }} data-id="element-270">
                        Valor: $49.999 COP — Hoy: GRATIS
                      </p>
                    </div>
                  </div>
                </div>}
            </div>
            {/* Sorteo */}
            <div className="p-5 relative overflow-hidden rounded-b-2xl" style={{
            background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
            boxShadow: '0 0 30px rgba(255,215,0,0.15), inset 0 1px 0 rgba(255,255,255,0.1)'
          }} data-id="element-271">
              <style data-id="element-272">{`
                @keyframes sorteoShimmer {
                  0% { transform: translateX(-100%); }
                  100% { transform: translateX(200%); }
                }
                @keyframes sorteoPulse {
                  0%, 100% { box-shadow: 0 0 15px rgba(255,215,0,0.3), 0 0 30px rgba(255,215,0,0.1); }
                  50% { box-shadow: 0 0 25px rgba(255,215,0,0.5), 0 0 50px rgba(255,215,0,0.2); }
                }
              `}</style>
              <span className="pointer-events-none absolute inset-0" style={{
              background: 'linear-gradient(105deg, transparent 35%, rgba(255,215,0,0.08) 50%, transparent 65%)',
              animation: 'sorteoShimmer 3s linear infinite'
            }} data-id="element-273" />

              <div className="relative z-10" data-id="element-274">
                <div className="flex items-center gap-2 mb-3 justify-center" data-id="element-275">
                  <span className="text-xl" data-id="element-276">🎁</span>
                  <span className="text-sm font-black uppercase tracking-wider" style={{
                  color: '#FFD700'
                }} data-id="element-277">
                    Sorteos Especiales
                  </span>
                  <span className="text-xl" data-id="element-278">🎁</span>
                </div>

                {/* Sorteo 1 - Cama y comedero */}
                <div className="rounded-xl p-4 mb-3 border" style={{
                background: 'rgba(255,255,255,0.08)',
                borderColor: 'rgba(255,215,0,0.3)',
                animation: 'sorteoPulse 3s ease-in-out infinite'
              }} data-id="element-279">
                  <p className="text-xs font-bold text-white text-center mb-3 leading-snug" data-id="element-280">
                    🐾 Participa por una{' '}
                    <span style={{
                    color: '#FFD700'
                  }} data-id="element-281">
                      cama y un comedero
                    </span>{' '}
                    para consentir a tu perro
                  </p>
                  <div className="flex items-center justify-center gap-3" data-id="element-282">
                    <img src="https://cdn.magicpatterns.com/uploads/2vWbZS32sbqAgG7W3SwsJx/imagen_1x1.png" alt="Cama para perro" className="w-16 h-16 object-cover rounded-lg border-2 shadow-lg" style={{
                    borderColor: '#FFD700'
                  }} data-id="element-283" />
                    <img src="https://cdn.magicpatterns.com/uploads/2Y1yUZV5roAZKNA5ktyjhw/imagen_plato_perro_1x1.png" alt="Comedero para perro" className="w-16 h-16 object-cover rounded-lg border-2 shadow-lg" style={{
                    borderColor: '#FFD700'
                  }} data-id="element-284" />
                  </div>
                </div>

                {/* Sorteo 2 - Seguro veterinario */}
                <div className="rounded-xl p-4 mb-4 border" style={{
                background: 'rgba(255,255,255,0.08)',
                borderColor: 'rgba(255,215,0,0.3)',
                animation: 'sorteoPulse 3s ease-in-out infinite 1.5s'
              }} data-id="element-285">
                  <div className="flex items-center gap-2 mb-2 justify-center" data-id="element-286">
                    <span className="text-lg" data-id="element-287">🏥</span>
                    <span className="text-xs font-bold uppercase tracking-wide" style={{
                    color: '#FFD700'
                  }} data-id="element-288">
                      Seguro Veterinario SURA
                    </span>
                  </div>
                  <p className="text-xs font-bold text-white text-center mb-2 leading-snug" data-id="element-289">
                    SEGURO DE SALUD VETERINARIO PARA TU MASCOTA POR{' '}
                    <span style={{
                    color: '#FFD700'
                  }} data-id="element-290">
                      1 AÑO
                    </span>
                  </p>
                  <p className="text-[11px] text-gray-300 text-center leading-relaxed" data-id="element-291">
                    Cobertura que puede incluir: consultas veterinarias,
                    urgencias médicas, hospitalización, cirugías, exámenes y
                    medicamentos en clínica.
                  </p>
                </div>

                {/* Fecha grande */}
                <div className="rounded-xl py-3 px-4 text-center border" style={{
                background: 'linear-gradient(135deg, rgba(255,215,0,0.15), rgba(255,215,0,0.05))',
                borderColor: '#FFD700'
              }} data-id="element-292">
                  <p className="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1" data-id="element-293">
                    📅 Fecha del sorteo
                  </p>
                  <p className="text-xl md:text-2xl font-black uppercase tracking-wide" style={{
                  color: '#FFD700'
                }} data-id="element-294">
                    {(() => {
                    const tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    return tomorrow.toLocaleDateString('es-CO', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric'
                    });
                  })()}
                  </p>
                  <p className="text-[10px] text-gray-400 mt-1" data-id="element-295">
                    Ganador elegido al azar entre los correos de compradores
                  </p>
                  <p className="text-[11px] text-gray-300 mt-3 leading-relaxed italic" data-id="element-296">
                    La buena alimentación es clave para el bienestar de tu
                    perro, y este sorteo busca seguir promoviendo su salud.{' '}
                    <span style={{
                    color: '#FFD700'
                  }} data-id="element-297">
                      ¡Tú puedes ser el ganador!
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Value Stack */}
          <div className="max-w-xl mx-auto mt-8 bg-white border-2 rounded-2xl overflow-hidden shadow-lg" style={{
          borderColor: '#6DAA7F'
        }} data-id="element-298">
            <div className="px-6 py-4 border-b" style={{
            backgroundColor: '#FFF3E0',
            borderColor: '#6DAA7F'
          }} data-id="element-299">
              <p className="text-sm font-bold uppercase tracking-wider" style={{
              color: '#2F5D50'
            }} data-id="element-300">
                Valor estimado real
              </p>
            </div>
            <div className="px-6 py-4 space-y-3" data-id="element-301">
              <div className="flex items-center justify-between" data-id="element-302">
                <span className="text-sm text-gray-600" data-id="element-303">
                  Consulta nutricional veterinaria
                </span>
                <span className="text-sm font-bold text-gray-500 line-through" data-id="element-304">
                  $150.000+
                </span>
              </div>
              <div className="flex items-center justify-between" data-id="element-305">
                <span className="text-sm text-gray-600" data-id="element-306">
                  Plan alimenticio personalizado
                </span>
                <span className="text-sm font-bold text-gray-500 line-through" data-id="element-307">
                  $300.000+
                </span>
              </div>
              <div className="flex items-center justify-between" data-id="element-308">
                <span className="text-sm text-gray-600" data-id="element-309">
                  Guías especializadas
                </span>
                <span className="text-sm font-bold text-gray-500 line-through" data-id="element-310">
                  $150.000
                </span>
              </div>
              <div className="border-t-2 border-dashed pt-3 flex items-center justify-between" style={{
              borderColor: '#6DAA7F'
            }} data-id="element-311">
                <span className="text-sm font-bold text-gray-700" data-id="element-312">
                  Valor total estimado
                </span>
                <span className="text-base font-black text-gray-500 line-through" data-id="element-313">
                  $600.000+
                </span>
              </div>
            </div>
            <div className="px-6 py-5 text-center" style={{
            background: 'linear-gradient(to right, #2F5D50, #3d7a68)'
          }} data-id="element-314">
              <p className="text-white text-sm font-bold uppercase tracking-widest mb-1" data-id="element-315">
                Hoy acceso completo por
              </p>
              <p className="text-white text-4xl font-black" data-id="element-316">
                {displayPrice} <span className="text-xl font-bold" data-id="element-317">COP</span>
              </p>
              <div className="flex items-center justify-center gap-3 mt-3 flex-wrap" data-id="element-318">
                <span className="bg-white/20 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-319">
                  ✔ Pago único
                </span>
                <span className="bg-white/20 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-320">
                  ✔ Acceso inmediato
                </span>
                <span className="bg-white/20 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-321">
                  ✔ De por vida
                </span>
              </div>
              <div className="mt-4 px-2" data-id="element-322">
                <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full" onClick={handleCheckoutClick} data-id="element-323">
                  <button className="w-full text-white font-bold py-4 px-8 rounded-xl shadow-lg transition-all duration-200 hover:-translate-y-1 flex flex-col items-center justify-center gap-1 text-center leading-tight" style={{
                  background: 'linear-gradient(to right, #F57C00, #e07000)',
                  boxShadow: '0 8px 20px rgba(0,0,0,0.25)'
                }} onMouseEnter={e => e.currentTarget.style.background = 'linear-gradient(to right, #E66A00, #cc5f00)'} onMouseLeave={e => e.currentTarget.style.background = 'linear-gradient(to right, #F57C00, #e07000)'} data-id="element-324">
                    <span className="text-lg" data-id="element-325">COMPRAR AHORA</span>
                    <span className="text-sm opacity-90" data-id="element-326">
                      por {displayPrice} COP
                    </span>
                  </button>
                </a>
                <p className="text-center text-xs font-semibold mt-2 animate-pulse text-yellow-200" data-id="element-327">
                  ❤️ Si consideras a tu perro familia y lo amas, no lo pienses
                  más
                </p>
              </div>
            </div>
          </div>

          {/* Order Bumps - HIDDEN FOR NOW */}
          {false && <div className="max-w-xl mx-auto mt-6 space-y-4 text-left" data-id="element-328">
              <div className="text-center" data-id="element-329">
                <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider mb-1.5" style={{
              color: '#2F5D50'
            }} data-id="element-330">
                  <Star className="w-3.5 h-3.5 fill-current" style={{
                color: '#F57C00'
              }} data-id="element-331" />
                  Altamente recomendado
                  <Star className="w-3.5 h-3.5 fill-current" style={{
                color: '#F57C00'
              }} data-id="element-332" />
                </span>
              </div>
              <div id="order-bump-1" className={`relative rounded-xl overflow-hidden border-2 transition-all duration-200 cursor-pointer`} style={{
            borderColor: bump1Selected ? '#F57C00' : '#6DAA7F',
            boxShadow: bump1Selected ? '0 8px 24px rgba(245,124,0,0.2)' : 'none'
          }} onClick={() => setBump1Selected(!bump1Selected)} data-id="element-333">
                <div className="order-bump-flash px-4 py-2.5 flex items-center justify-between" style={{
              background: 'linear-gradient(to right, #F57C00, #e07000)'
            }} data-id="element-334">
                  <div className="flex items-center gap-3" data-id="element-335">
                    <div className={`w-6 h-6 rounded-md border-2 flex items-center justify-center transition-all`} style={{
                  backgroundColor: bump1Selected ? 'white' : 'rgba(255,255,255,0.2)',
                  borderColor: 'white'
                }} data-id="element-336">
                      {bump1Selected && <Check className="w-4 h-4" strokeWidth={3} style={{
                    color: '#F57C00'
                  }} data-id="element-337" />}
                    </div>
                    <span className="text-white text-xs font-bold uppercase tracking-wide" data-id="element-338">
                      ¡Sí, lo quiero! — Agregar a mi pedido
                    </span>
                  </div>
                </div>
                <div className="w-full" data-id="element-339">
                  <img src="https://cdn.magicpatterns.com/uploads/fsD5rTTzoVEYKeEw4P6S3y/order_1.png" alt="Cocina 1 vez por semana" className="w-full h-auto object-cover" data-id="element-340" />
                </div>
                <div className="p-4" style={{
              backgroundColor: '#FFF3E0'
            }} data-id="element-341">
                  <h5 className="text-base md:text-lg font-extrabold text-gray-900 leading-snug" data-id="element-342">
                    Cocina 1 vez por semana (sin improvisar)
                  </h5>
                  <p className="text-xs text-gray-600 mt-1.5 leading-relaxed" data-id="element-343">
                    Convierte las 30 recetas en un sistema semanal: eliges,
                    cocinas por lotes y porcionas.
                  </p>
                  <div className="mt-3 space-y-1.5" data-id="element-344">
                    {['Menos tiempo diario', 'Rotación sin caos digestivo', 'Audioguía manos libres incluida'].map((t, i) => <div key={i} className="flex items-start gap-2" data-id="element-345">
                        <Check className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={3} style={{
                    color: '#2F5D50'
                  }} data-id="element-346" />
                        <span className="text-xs text-gray-700" data-id="element-347">{t}</span>
                      </div>)}
                  </div>
                  <div className="mt-3 flex items-center justify-center gap-2 bg-white border-2 rounded-lg px-4 py-2.5" style={{
                borderColor: '#F57C00'
              }} data-id="element-348">
                    <Tag className="w-4 h-4" style={{
                  color: '#F57C00'
                }} data-id="element-349" />
                    <span className="text-lg font-extrabold" style={{
                  color: '#F57C00'
                }} data-id="element-350">
                      + $19.000 COP
                    </span>
                  </div>
                  <div className="mt-2 border rounded-lg px-3 py-2 flex items-center gap-2" style={{
                backgroundColor: '#FFF3E0',
                borderColor: '#F57C00'
              }} data-id="element-351">
                    <Check className="w-4 h-4 flex-shrink-0" strokeWidth={3} style={{
                  color: '#2F5D50'
                }} data-id="element-352" />
                    <span className="text-sm font-bold" style={{
                  color: '#2F5D50'
                }} data-id="element-353">
                      PDF + audios MP3 — descarga inmediata
                    </span>
                  </div>
                </div>
              </div>

              <div className="text-center" data-id="element-354">
                <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider mb-1.5" style={{
              color: '#6DAA7F'
            }} data-id="element-355">
                  <Star className="w-3.5 h-3.5 fill-current" style={{
                color: '#6DAA7F'
              }} data-id="element-356" />
                  Altamente recomendado
                  <Star className="w-3.5 h-3.5 fill-current" style={{
                color: '#6DAA7F'
              }} data-id="element-357" />
                </span>
              </div>
              <div className={`relative rounded-xl overflow-hidden border-2 transition-all duration-200 cursor-pointer`} style={{
            borderColor: bump2Selected ? '#2F5D50' : '#6DAA7F',
            boxShadow: bump2Selected ? '0 8px 24px rgba(47,93,80,0.2)' : 'none'
          }} onClick={() => setBump2Selected(!bump2Selected)} data-id="element-358">
                <div className="order-bump-flash px-4 py-2.5 flex items-center justify-between" style={{
              background: 'linear-gradient(to right, #2F5D50, #3d7a68)'
            }} data-id="element-359">
                  <div className="flex items-center gap-3" data-id="element-360">
                    <div className={`w-6 h-6 rounded-md border-2 flex items-center justify-center transition-all`} style={{
                  backgroundColor: bump2Selected ? 'white' : 'rgba(255,255,255,0.2)',
                  borderColor: 'white'
                }} data-id="element-361">
                      {bump2Selected && <Check className="w-4 h-4" strokeWidth={3} style={{
                    color: '#2F5D50'
                  }} data-id="element-362" />}
                    </div>
                    <span className="text-white text-xs font-bold uppercase tracking-wide" data-id="element-363">
                      ¡Sí, lo quiero! — Agregar a mi pedido
                    </span>
                  </div>
                </div>
                <div className="w-full" data-id="element-364">
                  <img src="https://cdn.magicpatterns.com/uploads/xgRuFDo3r8Pj8fZw2d5EnX/order_2.png" alt="Compra bien sin gastar de más" className="w-full h-auto object-cover" data-id="element-365" />
                </div>
                <div className="p-4" style={{
              backgroundColor: '#e8f5ec'
            }} data-id="element-366">
                  <h5 className="text-base md:text-lg font-extrabold text-gray-900 leading-snug" data-id="element-367">
                    Compra bien (sin gastar de más)
                  </h5>
                  <p className="text-xs text-gray-600 mt-1.5 leading-relaxed" data-id="element-368">
                    Ingredientes económicos + sustituciones rápidas + reglas
                    simples.
                  </p>
                  <div className="mt-3 space-y-1.5" data-id="element-369">
                    {['Lista de swaps por proteína', 'Recetas "baratas" favoritas', 'Reglas para no disparar el gasto'].map((t, i) => <div key={i} className="flex items-start gap-2" data-id="element-370">
                        <Check className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={3} style={{
                    color: '#6DAA7F'
                  }} data-id="element-371" />
                        <span className="text-xs text-gray-700" data-id="element-372">{t}</span>
                      </div>)}
                  </div>
                  <div className="mt-3 flex items-center justify-center gap-2 bg-white border-2 rounded-lg px-4 py-2.5" style={{
                borderColor: '#6DAA7F'
              }} data-id="element-373">
                    <Tag className="w-4 h-4" style={{
                  color: '#6DAA7F'
                }} data-id="element-374" />
                    <span className="text-lg font-extrabold" style={{
                  color: '#2F5D50'
                }} data-id="element-375">
                      + $17.000 COP
                    </span>
                  </div>
                  <div className="mt-2 border rounded-lg px-3 py-2 flex items-center gap-2" style={{
                backgroundColor: '#e8f5ec',
                borderColor: '#6DAA7F'
              }} data-id="element-376">
                    <Check className="w-4 h-4 flex-shrink-0" strokeWidth={3} style={{
                  color: '#2F5D50'
                }} data-id="element-377" />
                    <span className="text-sm font-bold" style={{
                  color: '#2F5D50'
                }} data-id="element-378">
                      PDF + audios MP3 — precio especial hoy en tu compra
                    </span>
                  </div>
                </div>
              </div>
            </div>}

          {/* Order Summary - HIDDEN FOR NOW */}
          {false && <div className="mt-5 bg-white border-2 rounded-xl p-4 shadow-sm" style={{
          borderColor: '#6DAA7F'
        }} data-id="element-379">
              <div className="flex items-center gap-2 mb-3" data-id="element-380">
                <ShoppingCart className="w-4 h-4 text-gray-700" data-id="element-381" />
                <span className="text-sm font-bold text-gray-800" data-id="element-382">
                  Tu pedido
                </span>
              </div>
              <div className="space-y-2" data-id="element-383">
                <div className="flex items-center justify-between" data-id="element-384">
                  <div className="flex items-center gap-2" data-id="element-385">
                    <CheckCircle2 className="w-4 h-4 flex-shrink-0" style={{
                  color: '#6DAA7F'
                }} data-id="element-386" />
                    <span className="text-xs text-gray-700" data-id="element-387">
                      30 Recetas + 3 Regalos Gratis
                    </span>
                  </div>
                  <span className="text-xs font-bold text-gray-800" data-id="element-388">
                    $19.999
                  </span>
                </div>
                {bump1Selected && <div className="flex items-center justify-between" data-id="element-389">
                    <div className="flex items-center gap-2" data-id="element-390">
                      <CheckCircle2 className="w-4 h-4 flex-shrink-0" style={{
                  color: '#F57C00'
                }} data-id="element-391" />
                      <span className="text-xs text-gray-700" data-id="element-392">
                        Cocina 1 vez por semana
                      </span>
                    </div>
                    <span className="text-xs font-bold text-gray-800" data-id="element-393">
                      $19.000
                    </span>
                  </div>}
                {bump2Selected && <div className="flex items-center justify-between" data-id="element-394">
                    <div className="flex items-center gap-2" data-id="element-395">
                      <CheckCircle2 className="w-4 h-4 flex-shrink-0" style={{
                  color: '#2F5D50'
                }} data-id="element-396" />
                      <span className="text-xs text-gray-700" data-id="element-397">
                        Compra bien (sin gastar de más)
                      </span>
                    </div>
                    <span className="text-xs font-bold text-gray-800" data-id="element-398">
                      $17.000
                    </span>
                  </div>}
              </div>
              <div className="mt-3 pt-3 border-t-2 border-dashed flex items-center justify-between" style={{
            borderColor: '#6DAA7F'
          }} data-id="element-399">
                <span className="text-sm font-extrabold text-gray-900" data-id="element-400">
                  TOTAL A PAGAR:
                </span>
                <span className="text-xl font-extrabold" style={{
              color: '#2F5D50'
            }} data-id="element-401">
                  ${orderTotal.toLocaleString('es-CO')} COP
                </span>
              </div>
              <a href={activeCheckoutUrl} target="_blank" rel="noopener noreferrer" className="block w-full mt-4" onClick={handleCheckoutClick} data-id="element-402">
                <button className="w-full text-white font-bold py-4 px-6 rounded-xl shadow-lg transition-all duration-200 hover:-translate-y-1 flex flex-col items-center justify-center gap-1" style={{
              background: 'linear-gradient(to right, #F57C00, #e07000)',
              boxShadow: '0 8px 20px rgba(245,124,0,0.3)'
            }} onMouseEnter={e => e.currentTarget.style.background = 'linear-gradient(to right, #E66A00, #cc5f00)'} onMouseLeave={e => e.currentTarget.style.background = 'linear-gradient(to right, #F57C00, #e07000)'} data-id="element-403">
                  <span className="text-base md:text-lg leading-tight" data-id="element-404">
                    COMPRAR AHORA
                  </span>
                  <span className="text-sm opacity-90" data-id="element-405">
                    por ${orderTotal.toLocaleString('es-CO')} COP
                  </span>
                </button>
              </a>
            </div>}
        </div>

        <div className="max-w-2xl mx-auto" data-id="element-406"></div>

        {/* Bonus Cards */}
        <div id="bonos-gratis" className="space-y-6 max-w-2xl mx-auto mt-6" data-id="element-407">
          {/* Bonos Header */}
          <div className="p-8 rounded-2xl text-white text-center shadow-xl relative overflow-hidden" style={{
          background: 'linear-gradient(135deg, #2F5D50, #3d7a68, #4a9680)'
        }} data-id="element-408">
            <div className="absolute top-0 left-0 w-32 h-32 bg-white/10 rounded-full blur-2xl -translate-x-1/2 -translate-y-1/2" data-id="element-409"></div>
            <div className="absolute bottom-0 right-0 w-24 h-24 bg-yellow-300/15 rounded-full blur-2xl translate-x-1/2 translate-y-1/2" data-id="element-410"></div>
            <div className="relative z-10" data-id="element-411">
              <div className="inline-flex items-center gap-2 bg-yellow-400 text-green-900 px-4 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-4" data-id="element-412">
                <Gift className="w-3.5 h-3.5" data-id="element-413" />
                Solo por hoy
              </div>
              <h3 className="text-2xl md:text-3xl font-extrabold uppercase tracking-tight mb-2 leading-tight" data-id="element-414">
                Hoy te llevas
                <br data-id="element-415" />
                <span className="text-yellow-300 text-3xl md:text-4xl" data-id="element-416">
                  3 BONOS GRATIS
                </span>
              </h3>
              <div className="flex items-center justify-center gap-2 mb-5" data-id="element-417">
                <Tag className="w-4 h-4 text-yellow-200" data-id="element-418" />
                <p className="text-sm font-semibold text-green-100" data-id="element-419">
                  Valor: $49.999 COP c/u
                </p>
              </div>
              <p className="text-sm text-white/90 leading-relaxed max-w-md mx-auto" data-id="element-420">
                Si hoy decides llevarte el paquete, no solo recibes el ebook
                principal... también te incluyo 3 regalos diseñados para que
                apliques las recetas sin errores, con más seguridad y con
                resultados más rápidos.
              </p>
              <div className="mt-5 pt-4 border-t border-white/20 flex items-center justify-center gap-4 text-xs font-medium" data-id="element-421">
                <span data-id="element-422">
                  Valor normal:{' '}
                  <span className="line-through" data-id="element-423">$49.999 COP c/u</span>
                </span>
                <span className="bg-yellow-400 text-green-900 px-4 py-1.5 rounded-full font-extrabold text-sm shadow-md" data-id="element-424">
                  Hoy: $0 COP
                </span>
              </div>
            </div>
          </div>

          {/* Bonus Card #1 - Lista Negra + Lista Verde */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border-2 relative overflow-hidden" style={{
          borderColor: '#6DAA7F'
        }} data-id="element-425">
            <div className="absolute top-0 right-0 text-white text-xs font-bold px-4 py-2 rounded-bl-xl uppercase tracking-wider flex items-center gap-1 shadow-sm" style={{
            backgroundColor: '#2F5D50'
          }} data-id="element-426">
              <Gift className="w-3 h-3" data-id="element-427" />
              Bono #1 Gratis
            </div>
            <div className="flex flex-col sm:flex-row gap-5 mb-5" data-id="element-428">
              <div className="w-32 sm:w-36 flex-shrink-0 mx-auto sm:mx-0 rounded-xl overflow-hidden shadow-lg border-2" style={{
              borderColor: '#e8f5ec'
            }} data-id="element-429">
                <img src="https://cdn.magicpatterns.com/uploads/dhzCPguBEHAuB1vxaooPGU/ChatGPT_Image_5_feb_2026,_02_35_47_p.m..png" alt="Lista Negra + Lista Verde" className="w-full h-full object-cover object-top aspect-[3/4]" data-id="element-430" />
              </div>
              <div className="flex-1" data-id="element-431">
                <div className="flex items-center gap-2 mb-2" data-id="element-432">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{
                  backgroundColor: '#e8f5ec',
                  color: '#2F5D50'
                }} data-id="element-433">
                    <ShieldCheck className="w-4 h-4" data-id="element-434" />
                  </div>
                  <h4 className="text-lg font-bold text-gray-900" data-id="element-435">
                    Lista Negra + Lista Verde
                  </h4>
                </div>
                <p className="text-sm font-medium mb-2" style={{
                color: '#2F5D50'
              }} data-id="element-436">
                  Alimentos Seguros y Prohibidos para Perros (Guía Rápida)
                </p>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-437">
                  Si hay algo que frena a muchos dueños es esto: "¿Y si le doy
                  algo que le haga daño?" Con este bono, en minutos tendrás una
                  guía clara para saber qué ingredientes son seguros, cuáles
                  usar con cuidado y cuáles evitar por completo.
                </p>
              </div>
            </div>
            <div className="space-y-2 p-4 rounded-xl border mb-4" style={{
            backgroundColor: '#e8f5ec',
            borderColor: '#6DAA7F'
          }} data-id="element-438">
              <p className="text-xs font-bold flex items-center gap-1.5 mb-2" style={{
              color: '#2F5D50'
            }} data-id="element-439">
                <BookOpen className="w-3.5 h-3.5" data-id="element-440" /> Incluye:
              </p>
              <div className="flex items-start gap-2" data-id="element-441">
                <XCircle className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-442" />
                <span className="text-gray-700 text-xs" data-id="element-443">
                  <strong data-id="element-444">Lista Negra (Prohibidos):</strong> explicada simple
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-445">
                <AlertTriangle className="w-4 h-4 text-yellow-500 flex-shrink-0 mt-0.5" data-id="element-446" />
                <span className="text-gray-700 text-xs" data-id="element-447">
                  <strong data-id="element-448">Lista Amarilla (Con cuidado):</strong> para evitar
                  errores típicos
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-449">
                <Leaf className="w-4 h-4 flex-shrink-0 mt-0.5" style={{
                color: '#6DAA7F'
              }} data-id="element-450" />
                <span className="text-gray-700 text-xs" data-id="element-451">
                  <strong data-id="element-452">Lista Verde (Seguros):</strong> para cocinar con
                  confianza
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-453">
                <FileText className="w-4 h-4 flex-shrink-0 mt-0.5" style={{
                color: '#2F5D50'
              }} data-id="element-454" />
                <span className="text-gray-700 text-xs" data-id="element-455">
                  Hoja imprimible para la nevera: "Permitido / Con cuidado /
                  Prohibido"
                </span>
              </div>
            </div>
            <div className="flex items-center justify-between px-4 py-2.5 rounded-lg" style={{
            backgroundColor: '#e8f5ec'
          }} data-id="element-456">
              <span className="text-xs text-gray-600" data-id="element-457">
                Valor: <span className="line-through" data-id="element-458">$49.999 COP</span>
              </span>
              <span className="text-sm font-bold flex items-center gap-1" style={{
              color: '#2F5D50'
            }} data-id="element-459">
                <ArrowRight className="w-3 h-3" data-id="element-460" /> HOY: GRATIS
              </span>
            </div>
          </div>

          {/* Bonus Card #2 - Plan Express 7 Días */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border-2 relative overflow-hidden" style={{
          borderColor: '#F57C00'
        }} data-id="element-461">
            <div className="absolute top-0 right-0 text-white text-xs font-bold px-4 py-2 rounded-bl-xl uppercase tracking-wider flex items-center gap-1 shadow-sm" style={{
            backgroundColor: '#F57C00'
          }} data-id="element-462">
              <Gift className="w-3 h-3" data-id="element-463" />
              Bono #2 Gratis
            </div>
            <div className="flex flex-col sm:flex-row gap-5 mb-5" data-id="element-464">
              <div className="w-32 sm:w-36 flex-shrink-0 mx-auto sm:mx-0 rounded-xl overflow-hidden shadow-lg border-2" style={{
              borderColor: '#FFF3E0'
            }} data-id="element-465">
                <img src="https://cdn.magicpatterns.com/uploads/tmJCjjYa4iD56VcWj6sEtX/ChatGPT_Image_5_feb_2026,_12_53_16_p.m..png" alt="Plan Express 7 Días" className="w-full h-full object-cover object-top aspect-[3/4]" data-id="element-466" />
              </div>
              <div className="flex-1" data-id="element-467">
                <div className="flex items-center gap-2 mb-2" data-id="element-468">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{
                  backgroundColor: '#FFF3E0',
                  color: '#F57C00'
                }} data-id="element-469">
                    <Calendar className="w-4 h-4" data-id="element-470" />
                  </div>
                  <h4 className="text-lg font-bold text-gray-900" data-id="element-471">
                    Plan Express 7 Días
                  </h4>
                </div>
                <p className="text-sm font-medium mb-2" style={{
                color: '#F57C00'
              }} data-id="element-472">
                  Transición Segura a Comida Casera (Sin Diarrea)
                </p>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-473">
                  El error #1 al empezar con comida casera es cambiar de
                  golpe... y ahí vienen los problemas: malestar, diarrea, gases
                  y frustración. Por eso te regalo este plan paso a paso para
                  que sepas exactamente qué hacer durante 7 días, cómo ajustar y
                  cómo avanzar sin improvisar.
                </p>
              </div>
            </div>
            <div className="space-y-2 p-4 rounded-xl border mb-4" style={{
            backgroundColor: '#FFF3E0',
            borderColor: '#F57C00'
          }} data-id="element-474">
              <p className="text-xs font-bold flex items-center gap-1.5 mb-2" style={{
              color: '#F57C00'
            }} data-id="element-475">
                <BookOpen className="w-3.5 h-3.5" data-id="element-476" /> Incluye:
              </p>
              <div className="flex items-start gap-2" data-id="element-477">
                <Check className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={3} style={{
                color: '#2F5D50'
              }} data-id="element-478" />
                <span className="text-gray-700 text-xs" data-id="element-479">
                  Plan día 1 al 7 (simple y directo)
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-480">
                <Check className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={3} style={{
                color: '#2F5D50'
              }} data-id="element-481" />
                <span className="text-gray-700 text-xs" data-id="element-482">
                  "Si pasa X → haces Y" (guía rápida de ajustes)
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-483">
                <Check className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={3} style={{
                color: '#2F5D50'
              }} data-id="element-484" />
                <span className="text-gray-700 text-xs" data-id="element-485">
                  Checklist de señales normales vs señales de alerta
                </span>
              </div>
            </div>
            <div className="flex items-center justify-between px-4 py-2.5 rounded-lg" style={{
            backgroundColor: '#FFF3E0'
          }} data-id="element-486">
              <span className="text-xs text-gray-600" data-id="element-487">
                Valor: <span className="line-through" data-id="element-488">$49.999 COP</span>
              </span>
              <span className="text-sm font-bold flex items-center gap-1" style={{
              color: '#F57C00'
            }} data-id="element-489">
                <ArrowRight className="w-3 h-3" data-id="element-490" /> HOY: GRATIS
              </span>
            </div>
          </div>

          {/* Bonus Card #3 - Alargar la Vida */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-md border-2 relative overflow-hidden" style={{
          borderColor: '#6DAA7F'
        }} data-id="element-491">
            <div className="absolute top-0 right-0 text-white text-xs font-bold px-4 py-2 rounded-bl-xl uppercase tracking-wider flex items-center gap-1 shadow-sm" style={{
            backgroundColor: '#2F5D50'
          }} data-id="element-492">
              <Gift className="w-3 h-3" data-id="element-493" />
              Bono #3 Gratis
            </div>
            <div className="flex flex-col sm:flex-row gap-5 mb-5" data-id="element-494">
              <div className="w-32 sm:w-36 flex-shrink-0 mx-auto sm:mx-0 rounded-xl overflow-hidden shadow-lg border-2" style={{
              borderColor: '#e8f5ec'
            }} data-id="element-495">
                <img src="https://cdn.magicpatterns.com/uploads/9pgdegNzbQ4opBiEgx4YKA/heylloyd-image-1769029546802.png" alt="Cómo Alargar la Vida de tu Perro" className="w-full h-full object-cover object-top aspect-[3/4]" data-id="element-496" />
              </div>
              <div className="flex-1" data-id="element-497">
                <div className="flex items-center gap-2 mb-2" data-id="element-498">
                  <div className="w-8 h-8 rounded-full flex items-center justify-center" style={{
                  backgroundColor: '#e8f5ec',
                  color: '#2F5D50'
                }} data-id="element-499">
                    <Heart className="w-4 h-4" data-id="element-500" />
                  </div>
                  <h4 className="text-lg font-bold text-gray-900" data-id="element-501">
                    Cómo Alargar la Vida de tu Perro
                  </h4>
                </div>
                <p className="text-sm font-medium mb-2" style={{
                color: '#2F5D50'
              }} data-id="element-502">
                  Guía de Hábitos Diarios
                </p>
                <p className="text-sm text-gray-600 leading-relaxed" data-id="element-503">
                  Las recetas son el punto de partida... pero la verdadera
                  diferencia está en los hábitos que repites todos los días.
                  Este bono te da una guía clara para crear una rutina simple
                  que mejora la calidad de vida de tu perro y te ayuda a
                  detectar señales tempranas antes de que sea tarde.
                </p>
              </div>
            </div>
            <div className="space-y-2 p-4 rounded-xl border mb-4" style={{
            backgroundColor: '#e8f5ec',
            borderColor: '#6DAA7F'
          }} data-id="element-504">
              <p className="text-xs font-bold flex items-center gap-1.5 mb-2" style={{
              color: '#2F5D50'
            }} data-id="element-505">
                <BookOpen className="w-3.5 h-3.5" data-id="element-506" /> Lo que vas a encontrar
                dentro:
              </p>
              <div className="flex items-start gap-2" data-id="element-507">
                <Check className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={3} style={{
                color: '#2F5D50'
              }} data-id="element-508" />
                <span className="text-gray-700 text-xs" data-id="element-509">
                  Rutina diaria simple (fácil de mantener)
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-510">
                <Check className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={3} style={{
                color: '#2F5D50'
              }} data-id="element-511" />
                <span className="text-gray-700 text-xs" data-id="element-512">
                  Hábitos de prevención (para dueños reales, sin complicarte)
                </span>
              </div>
              <div className="flex items-start gap-2" data-id="element-513">
                <Check className="w-4 h-4 flex-shrink-0 mt-0.5" strokeWidth={3} style={{
                color: '#2F5D50'
              }} data-id="element-514" />
                <span className="text-gray-700 text-xs" data-id="element-515">
                  Listas de chequeo imprimibles (para seguirlo sin pensar)
                </span>
              </div>
            </div>
            <div className="flex items-center justify-between px-4 py-2.5 rounded-lg" style={{
            backgroundColor: '#e8f5ec'
          }} data-id="element-516">
              <span className="text-xs text-gray-600" data-id="element-517">
                Valor: <span className="line-through" data-id="element-518">$49.999 COP</span>
              </span>
              <span className="text-sm font-bold flex items-center gap-1" style={{
              color: '#2F5D50'
            }} data-id="element-519">
                <ArrowRight className="w-3 h-3" data-id="element-520" /> HOY: GRATIS
              </span>
            </div>
          </div>

          {/* Summary Card */}
          <div className="bg-gradient-to-br from-gray-900 to-gray-800 p-6 rounded-2xl text-white shadow-xl" data-id="element-521">
            <div className="flex items-center gap-2 mb-4" data-id="element-522">
              <Star className="w-5 h-5 fill-current" style={{
              color: '#F57C00'
            }} data-id="element-523" />
              <h4 className="text-lg font-bold uppercase tracking-wide" data-id="element-524">
                Resumen rápido — Lo que te llevas hoy
              </h4>
            </div>
            <div className="space-y-2.5 mb-5" data-id="element-525">
              <div className="flex items-center gap-3" data-id="element-526">
                <CheckCircle2 className="w-4 h-4 flex-shrink-0" style={{
                color: '#F57C00'
              }} data-id="element-527" />
                <span className="text-sm text-gray-200" data-id="element-528">
                  Ebook principal:{' '}
                  <strong className="text-white" data-id="element-529">30 Recetas para Perros</strong>
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-530">
                <CheckCircle2 className="w-4 h-4 flex-shrink-0" style={{
                color: '#6DAA7F'
              }} data-id="element-531" />
                <span className="text-sm text-gray-200" data-id="element-532">
                  Bono #1:{' '}
                  <strong className="text-white" data-id="element-533">
                    Cómo Alargar la Vida de tu Perro
                  </strong>
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-534">
                <CheckCircle2 className="w-4 h-4 flex-shrink-0" style={{
                color: '#F57C00'
              }} data-id="element-535" />
                <span className="text-sm text-gray-200" data-id="element-536">
                  Bono #2:{' '}
                  <strong className="text-white" data-id="element-537">Plan Express 7 Días</strong>
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-538">
                <CheckCircle2 className="w-4 h-4 flex-shrink-0" style={{
                color: '#6DAA7F'
              }} data-id="element-539" />
                <span className="text-sm text-gray-200" data-id="element-540">
                  Bono #3:{' '}
                  <strong className="text-white" data-id="element-541">
                    Lista Negra + Lista Verde
                  </strong>
                </span>
              </div>
            </div>
            <div className="border-t border-gray-700 pt-4" data-id="element-542">
              <p className="text-xs text-gray-400 leading-relaxed flex items-start gap-2" data-id="element-543">
                <ShieldAlert className="w-4 h-4 text-yellow-400 flex-shrink-0 mt-0.5" data-id="element-544" />
                <span data-id="element-545">
                  <strong className="text-gray-300" data-id="element-546">Importante:</strong> Estos
                  regalos son una ayuda práctica para que implementes más
                  rápido, evites errores y cocines con tranquilidad.
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}